import styled from 'styled-components';

export default styled.p`
    font-size: 0.75rem;
    a {
        text-decoration: underline;
    }
`;
